
import { useParams } from 'react-router-dom';
import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from '../../../util/core/Session';
import config from '../../../../application/config/config';
import Toast from '../Util/Toast/Toast';
import CustomInputExample from '../Util/Form/CustomInputs/CustomInputExample';
import { useDispatch } from 'react-redux';
import { useKeysStore } from '../../../store/useKeysStore';

function Form() {
    const {keys} = useKeysStore();
    const session = getUserSession();
    const { id } = useParams();
    const dispatch = useDispatch();

    const path = '/core/examples/crud/backend/';
    const token = keys?.tokens?.whatsapp_api;
    const paths = {
        endpointSave: config.endpoints.backend + 'core/crudexample/save',
        endpointQrcode: config.endpoints.backend + 'core/crudexample/qrcode',
        endpointLogout: config.endpoints.backend + 'core/crudexample/logout',
        endpointExample: config.endpoints.backend + 'core/crudexample/getexample',
        endpointSearch: config.endpoints.backend + 'core/crudexample/searchexemple',
        endpointGetById: config.endpoints.backend + 'core/crudexample/getById',
        endpointGetSelectReferencePoints:
            config.endpoints.backend +
            'core/crudexample/getselectreferencepointsexample',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleAdd: 'Nova Empresa',
        labelTitleEdit: 'Editar Empresa',
        labelTitleView: 'Visualizar Empresa'
    };

    function getCurrentDateTime() {
        const now = new Date();
        return now.toISOString();
    }

    function getCurrentDateTimeAdd() {
        const now = new Date();
        now.setHours(now.getHours() + 1);
        return now.toISOString();
    }

    function getCurrentTime() {
        const now = new Date();
        return now.toTimeString().split(' ')[0]; 
    }
    
    function getCurrentTimePlusOneHour() {
        const now = new Date();
        now.setHours(now.getHours() + 1);
        return now.toTimeString().split(' ')[0]; 
    }

    let form = {
        searchField: 'students',
        validateOnChange: true,
        labelSubmitButton: 'Enviar',
        hiddenValues: {
            core_application_instance_id: session.user.application_instance_id,
            core_user_id: session.user.id
        },
        modalOptions: {
            title: 'Modal Teste',
            size: 'md',
            showButtons: false,
            content: <div>Modal Teste</div>
        },
        fields: [
            {
                name: 'selectgroups',
                type: 'selectwithgroups',
                options: [
                    {
                        label: "Cores", options: [
                            { label: 'Verde', value: '0' },
                            { label: 'Azul', value: '1' }
                        ]
                    },
                    {
                        label: "Frutas", options: [
                            { label: 'Abacaxi', value: '2' },
                            { label: 'Laranja', value: '3' }
                        ]
                    }
                ],
                label: 'Select com Grupos',
                validations: {
                    required: false
                },
                placeholder: 'teste',
                columnSize: 12,
                isClearable: false
            },
            {
                name: 'label',
                type: 'label',
                label: 'Label',
                value: <span style={{ color: 'blue' }}>Label teste</span>,
                validations: {
                    required: false
                },

                columnSize: 12
            },
            {
                name: 'number_field',
                type: 'integer',
                label: 'Teste placeholder',
                tooltip: {
                    title: 'Teste',
                    description: 'O teste indica alguma coisa'
                },
                placeholder: '0',
                validations: {
                    required: false
                },
                columnSize: 12,
                maxLength: 5
            },
            // {
            //     name: 'route',
            //     type: 'routes',
            //     label: 'Rotas',
            //     inputType: 'autocomplete',
            //     validations: {
            //         required: false
            //     },
            //     columnSize: 12
            // },
            // {
            //     name: 'route2',
            //     type: 'routes',
            //     label: 'Rotas',
            //     inputType: 'select',
            //     selectParams: {
            //         optionsEndpoint: {
            //             endpoint: paths.endpointGetSelectReferencePoints,
            //             fieldJsonAddress: 'address',
            //             label: 'label',
            //             value: 'id'
            //         },
            //         options: []
            //     },
            //     validations: {
            //         required: false
            //     },
            //     columnSize: 12
            // },
            {
                name: 'cnpj',
                type: 'CNPJ',
                label: 'CNPJ',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'cpf',
                type: 'CPF',
                label: 'CPF',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'rg',
                type: 'RG',
                label: 'RG',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'company_name',
                type: 'text',
                label: 'Razão social',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'company_fantasy_name',
                type: 'text',
                label: 'Nome fantasia',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'responsible_name',
                type: 'text',
                label: 'Responsável',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'responsible_birthday',
                type: 'date',
                label: 'Responsável data de nascimento',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'students',
                type: 'searchInput',
                label: 'Search',
                validations: {
                    required: false
                },
                endpoint: `${config.endpoints.backend}core/crudexample/searchexample`,
                searchParams: {
                    core_application_instance_id: '1234564'
                },
                nameTable: 'Alunos',
                options: [
                    {
                        width: '10%',
                        name: 'photo',
                        label: 'Foto',
                        type: 'image'
                    },
                    {
                        width: '50%',
                        name: 'student_name',
                        label: 'Nome',
                        type: 'text'
                    }
                ],
                columnSize: 12
            },
            {
                name: 'gender',
                type: 'select',
                options: [
                    { label: 'Masculino', value: 'M' },
                    { label: 'Feminino', value: 'F' }
                ],
                label: 'Gênero',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'multiselect_field',
                type: 'multiselect',
                options: [],
                optionsEndpoint: {
                    endpoint: config.endpoints.backend + 'core/users/getall',
                    label: 'name',
                    value: 'id'
                },
                label: 'Multi seleção',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'fone_1',
                type: 'phone',
                label: 'Telefone 1',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'fone_2',
                type: 'phone',
                label: 'Telefone 2',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'address',
                type: 'address',
                label: 'Endereço',
                googleMap: true,
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'file',
                type: 'file',
                label: 'Anexo Local',
                uploadPath: '/crud_example/',
                extensionAccept: '.jpeg,.jpg,.png,.pdf',
                limitFileSize: 2,
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'files3',
                type: 'fileS3',
                label: 'Anexo S3',
                description: () => {
                    return (
                        <>
                            <br />
                            <span style={{ fontSize: '15px', color: '#777' }}>
                                Recomendado: 500x250
                            </span>
                        </>
                    )
                },
                uploadPath: 'crud_example',
                extensionAccept: '.jpeg,.jpg,.png,.pdf',
                limitFileSize: 2,
                imageCompress: true,
                imageCompress: true,
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'videofiles3',
                type: 'fileS3',
                label: 'Video S3',
                uploadPath: 'crud_example_videos',
                extensionAccept: '.mp4, .mov',
                limitFileSize: 20,
                maxDuration: 120,
                confirmRemove: true,
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'multifiles3',
                type: 'multiUploadFileS3',
                label: 'Multiplos anexos S3',
                uploadPath: 'crud_example',
                extensionAccept: '.jpeg,.jpg,.png,.pdf',
                limitFileSize: 2,
                imageCompress: true,
                uploadFileLimit: 3,
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                label: 'Horário',
                type: 'time',
                defaultValue: getCurrentTime(),
                name: 'example_time_current',
                validations: {
                    required: false
                },
            },
            {
                label: 'Horário + 1',
                type: 'time',
                defaultValue: getCurrentTimePlusOneHour(),
                name: 'example_time_add',
                validations: {
                    required: false
                },
            },
            {
                name: 'orders',
                type: 'multiinput',
                label: 'Pedidos',
                sortBy: 'index',
                showDeleteButton: true,
                form: [
                    {
                        label: 'Seleção',
                        type: 'checkboxStylized',
                        name: 'selection',
                        validations: {
                            required: false
                        },
                        columnSize: 12
                    },
                    {
                        label: 'Ordem',
                        name: 'index',
                        type: 'integer',
                        maxLength: 2,
                        validations: {
                            required: true
                        },
                        styleTh: { width: '7%' }
                    },
                    {
                        name: 'files3',
                        type: 'fileS3',
                        label: 'Anexo S3',
                        uploadPath: 'crud_example',
                        extensionAccept: '.jpeg,.jpg,.png,.pdf',
                        limitFileSize: 2,
                        validations: {
                            required: false
                        },
                        columnSize: 12
                    },
                    {
                        name: 'opcao',
                        type: 'select',
                        options: [
                            { label: 'Opção 1', value: '1' },
                            { label: 'Opção 2', value: '2' }
                        ],
                        label: 'Opção',
                        styleTh: { width: '30%' },
                        validations: {
                            required: true
                        },
                    },
                    {
                        label: 'Tempo em segundos',
                        type: 'text',
                        name: 'seconds',
                        validations: {
                            required: true
                        },
                    },
                    {
                        label: 'Data',
                        type: 'date',
                        name: 'example_date',
                        validations: {
                            required: false
                        },
                    },
                    {
                        label: 'Valor',
                        type: 'decimal',
                        name: 'order_value',
                        validations: {
                            required: true
                        },
                    },
                    {
                        label: 'Telefone',
                        type: 'phone',
                        name: 'example_phone',
                        validations: {
                            required: true
                        },
                    },
                    {
                        label: 'Horário',
                        type: 'time',
                        name: 'example_time',
                        validations: {
                            required: false
                        },
                    },
                ],

                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'teste_multiinput',
                type: 'multiinput',
                label: 'Pedidos',
                sortBy: 'index',
                form: [
                    {
                        label: 'Texto',
                        type: 'text',
                        name: 'seconds',
                        validations: {
                            required: true
                        },
                    },
                ],

                validations: {
                    required: true,
                    custom: true,
                },
                columnSize: 12
            },
            id
                ? {
                    name: 'qrcode',
                    type: 'whatsappqrcode',
                    label: 'QRCODE',
                    id: id,
                    phone_name: 'fone_1', // Name column phone authenticator
                    endpoint: paths.endpointGetById,
                    endpointqrcode: paths.endpointQrcode,
                    endpointlogout: paths.endpointLogout,
                    token: token,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
                : {},
            {
                name: 'exampleqrcode',
                type: 'qrcode',
                label: 'QRcode',
                size: 150,
                value: 'https://origin9.com.br/'
            },
            {
                name: 'quantity',
                type: 'integer',
                label: 'Quantidade',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'phone_international',
                type: 'phone-international',
                label: 'Telefone Internacional',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'decimal_field',
                type: 'decimal',
                label: 'Número decimal',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'year_field',
                type: 'year',
                label: 'Ano - Selecionável',
                validations: {
                    required: false
                },
                selectable: true,
                columnSize: 6
            },
            {
                name: 'year_digit',
                type: 'year',
                label: 'Ano - Digitar (Apenas para visualização)',
                validations: {
                    required: false
                },
                columnSize: 6
            },
            {
                name: 'icon',
                type: 'selectIcons',
                label: 'Ícones',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Enviar',
                columnSize: 12
            },
            {
                name: 'color',
                type: 'color',
                label: 'Cor',
                validations: {
                    required: false
                },
                columnSize: 1
            },
            {
                name: 'month_year',
                type: 'month',
                label: 'Mes/Ano',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'multiapisearch',
                type: 'multiApiSearch',
                label: 'Multiplas Pesquisas em API',
                required_input_search: true,
                endpoint: `${config.endpoints.backend}core/crudexample/getmultiexample`,
                endpoint_method: 'post',
                endpoint_filter: 'name',
                response_type: 'multiple',
                label_column: 'Nome',
                label_path: 'name',
                value_path: '',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'multiapisearchexample',
                type: 'multiApiSearch',
                label: 'Multiplas Pesquisas em API Multiple (Apenas exemplo)',
                endpoint: `https://reqres.in/api/users?delay=3`,
                endpoint_method: 'get',
                endpoint_filter: false,
                response_type: 'multiple',
                label_column: 'Email',
                label_path: 'email',
                value_path: 'data',
                required_input_search: false,
                validations: {
                    required: false
                }
            },
            {
                name: 'datetime',
                type: 'datetime',
                label: 'Date Time',
                validations: {
                    required: false
                },
                defaultValue: getCurrentDateTime(),
                columnSize: 12
            },
            {
                name: 'date_time_add',
                type: 'datetime',
                label: 'Date Time',
                validations: {
                    required: false
                },
                defaultValue: getCurrentDateTimeAdd(),
                columnSize: 12
            },
            {
                name: 'signature',
                type: 'signature',
                label: 'Assinatura',
                uploadPath: 'signatureTest',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'radio_group',
                type: 'radioGroup',
                label: 'Radio ',
                options: [
                    {
                        label: 'Sim',
                        value: '1',
                        selected: true
                    },
                    {
                        label: 'Não',
                        value: '0'
                    }
                ],
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'radio_group_disabled',
                type: 'radioGroup',
                label: 'Radio Desativado',
                options: [
                    {
                        label: 'Sim',
                        value: '1',
                        selected: true
                    },
                    {
                        label: 'Não',
                        value: '0'
                    }
                ],
                validations: {
                    required: false
                },
                readOnly: true,
                columnSize: 12
            },
            {
                name: 'switch_value',
                type: 'checkbox',
                switch: true,
                label: 'Switch',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'period_example',
                name_start: 'date_start',
                name_end: 'date_end',
                type: 'date_period',
                label: 'Periodo de teste',
                validations: {
                    required: true,
                },
                columnSize: 12,
            },
            {
                name: 'institutional_email',
                type: 'email',
                label: 'Email Institutional',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'multicheckbox_field',
                type: 'multicheckbox',
                options: [],
                optionsEndpoint: {
                    label: 'name',
                    value: 'id',
                    endpoint: config.endpoints.backend + 'core/users/getall',
                },
                switch: false,
                showSelectAll: true,
                label: 'Multi Checkbox',
                validations: {
                    required: false
                },
                columnSize: 12
            },
            {
                name: 'custom',
                type: 'customInput',
                label: 'CustomInput',
                validations: {
                    required: true,
                    custom: true,
                },
                component: (params) => {
                    return (
                        <CustomInputExample
                            type='text'
                            name={params.item.name}
                            value={params.values[params.item.name]}
                            onChange={params.handleChange}
                            error={params.errors[params.item.name]}
                            readOnly={(params.item.readOnly || form.readOnly) ? true : false}
                            autoFocus={params.item.autoFocus}
                            ref={(el) => (params.inputRefs.current[params.item.name] = el)}
                        />
                    )
                },
                columnSize: 12
            },
        ],
        customValidators: {
            custom: (value, options, key, attributes) => {
                if (value === "") {
                    return '^Validação customizada'
                } else {
                    return '';
                }
            },
        },
        buttonsFooter: [
            {
                label: 'Custom button',
                onClick: (form) => {
                    Toast.success('Custom button');
                },
                className: 'btn btn-danger'
            },
            {
                label: 'Abrir Modal',
                onClick: (form) => {
                    dispatch({ type: 'UPDATE_SESSION', key: 'custom_show_modal', value: true })
                },
                className: 'btn btn-success'
            },
        ],
        ...paths,
        ...labels,
    };

    return (
        <div>
            <CustomFormContainer
                form={form}
                content={<CustomForm form={form} />}
            />
        </div>
    );
}
export default Form;